import React, { useEffect, useRef } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { LineChart } from 'echarts/charts';
import {
    GridComponent,
    TooltipComponent,
    AxisPointerComponent,
    TitleComponent,
    TimelineComponent,
    MarkPointComponent,
    MarkLineComponent,
    LegendComponent,
    DataZoomComponent,
    DataZoomInsideComponent,
    DataZoomSliderComponent,
    VisualMapComponent,
    VisualMapContinuousComponent,
    VisualMapPiecewiseComponent,
} from 'echarts/components';
import {
    SVGRenderer,
} from 'echarts/renderers';
import { getMobileTooltip, getComputerTooltip, getAxisPointer, getMobileDataZoom, getComputerDataZoom } from '../util/GridA'
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

echarts.use(
    [AxisPointerComponent, SVGRenderer, VisualMapComponent, VisualMapContinuousComponent, VisualMapPiecewiseComponent, TitleComponent, TooltipComponent, GridComponent, LineChart, DataZoomComponent,
        DataZoomInsideComponent, DataZoomSliderComponent, MarkPointComponent, MarkLineComponent, TimelineComponent,
        LegendComponent]
);


const useStyles = makeStyles(theme => ({
    table: {
    },
    root1: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
    grid: {
        // width: `calc(100% + ${6 + theme.spacing(1)}px)`
    }
}));

// (p.o, p.h, p.l, p.p)) convert to //open，close，lowest，highest



export default function Fakk(props) {
    const classes = useStyles();
    const theme = useTheme();

    const [options, setOptions] = React.useState(null)
    const [data, setData] = React.useState(null)
    const [loading, setLoading] = React.useState(false);

    const [days, setDays] = React.useState(40)
    const [turn1, setTurn1] = React.useState(-1)
    const [turn2, setTurn2] = React.useState(-1)

    const getPHV1 = () => {
        setLoading(true)
        let lic = localStorage.getItem('lic')

        if (lic != null) {
            let param = {
                lic: lic,
                sid: props.row.market_company.stock_no,
                days: days,
                turn1: turn1,
                turn2: turn2
            };

            fetch("/jstock/v1/stock/fakk", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(param)
            })
                .then(res => res.json())
                .then(
                    result => {
                        setLoading(false)
                        if (result.data != null) {
                            setData(result.data)
                        }
                    }
                )

        }
    }

    function genData1() {
        let option = {
            animation: false,
            title: [
            ],
            grid: [
                {
                    top: '40',
                    left: '10',
                    right: '10',
                    height: '300',
                    borderWidth: 0,
                    borderColor: "#000205",
                    show: true
                }
            ],
            yAxis: [
                {
                    scale: true,
                    splitArea: {
                        show: false
                    },
                    show: true,
                    position: 'left',
                    axisLabel: {
                        inside: true,
                        margin: 0
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            opacity: 0.3
                        }
                    }
                }
            ]
        };


        let x1 = {
            type: 'category',
            data: data.data.map(v => { return v.x })
        }



        if (props.ismobile) {
            let xp = {
                type: 'shadow',
                label: { show: false },
                triggerTooltip: true,
                handle: {
                    show: true,
                    margin: 25,
                    color: '#1868d9',
                    size: 30
                }
            }

            x1['axisPointer'] = xp
        }

        option['xAxis'] = [x1]

        let xa = []
        xa.push(
            [
                {
                    name: '取樣區域',
                    xAxis: data.bymd,
                    itemStyle: {
                        borderWidth: 2,
                        borderType: 'dashed',
                        opacity: 0.3
                    }
                },
                {
                    xAxis: data.eymd
                }
            ]
        )

        if(turn1 != -1 || turn2 != -1) {
            xa.push(
                [
                    {
                        name: '預測區域',
                        xAxis: data.eymd,
                        itemStyle: {
                            borderWidth: 2,
                            borderType: 'dashed',
                            opacity: 0.3
                        }
                    },
                    {
                        xAxis: "D"
                    }
                ]
            )
        }

        option['series'] = [
            {
                name: '日K線',
                type: 'candlestick',
                data: data.data.map(vv => {
                    return [vv.y[0], vv.y[1], vv.y[2], vv.y[3]]
                }),
                itemStyle: {
                    color: "#d41c1c",
                    color0: '#65b206',
                    borderColor: "#d41c1c",
                    borderColor0: '#65b206'
                },
                selectedMode: 'single',
                markArea: {
                    data: xa
                }

            }
        ]


        if (props.ismobile) {
            option['tooltip'] = getMobileTooltip()
            option['axisPointer'] = getAxisPointer()
            option['dataZoom'] = getMobileDataZoom(0, 100)
        } else {
            option['tooltip'] = getComputerTooltip()
            option['axisPointer'] = getAxisPointer()
        }


        return option
    }


    useEffect(() => {
        if (data != null) setOptions(genData1())
    }, [data]);

    useEffect(() => {
        if (props.row != null) getPHV1()
    }, [props.row, days, turn1, turn2]);

    function getString() {
        return "目前無相關的K線預測圖"
    }

    return (
        <div>
            {localStorage.getItem('noad') != null && localStorage.getItem('noad') === "1" ? <Grid container spacing={0} className={classes.grid}>
                <Grid item xs={12} sm={12} >
                    <div style={{ display: 'flex', marginTop: 5, marginBottom: 5 }}>
                        <FormControl size="small" variant="filled" className={classes.formControl} style={{ marginLeft: 0 }}>
                            <InputLabel id="s1-label">天數</InputLabel>
                            <Select
                                style={{ minWidth: 80 }}
                                labelId="s1-label"
                                id="days"
                                value={days}
                                onChange={e => setDays(e.target.value)}
                            >
                                <MenuItem value={5}>近5日</MenuItem>
                                <MenuItem value={10}>近10日</MenuItem>
                                <MenuItem value={20}>近20日</MenuItem>
                                <MenuItem value={40}>近40日</MenuItem>
                                <MenuItem value={60}>近60日</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl size="small" variant="filled" className={classes.formControl} style={{ marginLeft: 5 }}>
                            <InputLabel id="s1-label">動作1</InputLabel>
                            <Select
                                style={{ minWidth: 80 }}
                                labelId="s2-label"
                                id="turn1"
                                value={turn1}
                                onChange={e => setTurn1(e.target.value)}
                            >
                                <MenuItem value={"-1"}>無動作</MenuItem>
                                <MenuItem value={"0"}>重複區塊</MenuItem>
                                <MenuItem value={"1"}>左右相反</MenuItem>
                                <MenuItem value={"2"}>上下顛倒</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl size="small" variant="filled" className={classes.formControl} style={{ marginLeft: 5 }}>
                            <InputLabel id="s1-label">動作2</InputLabel>
                            <Select
                                style={{ minWidth: 80 }}
                                labelId="s2-label"
                                id="turn2"
                                value={turn2}
                                onChange={e => setTurn2(e.target.value)}
                            >
                                <MenuItem value={"-1"}>無動作</MenuItem>
                                <MenuItem value={"0"}>重複區塊</MenuItem>
                                <MenuItem value={"1"}>左右相反</MenuItem>
                                <MenuItem value={"2"}>上下顛倒</MenuItem>
                            </Select>
                        </FormControl></div>

                    <div style={{ fontSize: 14, color: "#808080" }}>

                    </div>
                    {options != null ? <ReactEChartsCore
                        theme={theme.palette.type}
                        style={{ height: 400, marginTop: 0 }}
                        echarts={echarts}
                        option={options}
                        notMerge={true}
                        lazyUpdate={false}
                        showLoading={loading}
                    /> : <div style={{}}>{getString()}</div>}
                </Grid>

            </Grid> : <div>目前K線預測圖僅開放給訂閱者。</div>}
        </div >
    );
}